import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
};

interface DeleteAllHistoryModal {
  canShow: boolean;
  isDeleteLoading: boolean;
  handleClose: () => void;
  handleDeleteAllHistory: () => void;
  message: string;
}

export const DeleteAllHistoryModal = ({
  canShow,
  handleClose,
  handleDeleteAllHistory,
  isDeleteLoading,
  message,
}: DeleteAllHistoryModal) => {
  return (
    <div>
      <Modal
        open={canShow}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style} className="delete-all-history-modal">
          <Box className="delete-all-history-modal-header">
            <Typography>Delete Step</Typography>
          </Box>
          <Box className="delete-all-history-modal-body">
            <Typography>{message}</Typography>
          </Box>
          <Box className="delete-all-history-modal-footer">
            <Box className="history-modal-footer-cancel" onClick={handleClose}>
              Cancel
            </Box>
            <Box
              className={`history-modal-footer-confirm ${
                isDeleteLoading && "disabled"
              }`}
              onClick={handleDeleteAllHistory}
            >
              Confirm
            </Box>
          </Box>
        </Box>
      </Modal>
    </div>
  );
};
